var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"12","y1":"5","x2":"12","y2":"19","key":0}),React.createElement("line",{"x1":"5","y1":"12","x2":"19","y2":"12","key":1})]);
}

Plus.defaultProps = {"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"};

module.exports = Plus;

Plus.default = Plus;
